import { render, staticRenderFns } from "./CreateCombined.vue?vue&type=template&id=48735bdc&scoped=true"
import script from "./CreateCombined.vue?vue&type=script&lang=js"
export * from "./CreateCombined.vue?vue&type=script&lang=js"
import style0 from "./CreateCombined.vue?vue&type=style&index=0&id=48735bdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48735bdc",
  null
  
)

export default component.exports